module.exports = __webpack_public_path__ + "static/media/SY.6065fa16.svg";